module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "start",
      "no-gutters": ""
    }
  }, _vm._l((_vm.params.value), function(source) {
    return _c('v-col', {
      key: source,
      staticClass: "pa-1",
      attrs: {
        "cols": "2",
        "sm": "3",
        "md": "6",
        "lg": "4",
        "xl": "2"
      }
    }, [_c('v-img', {
      attrs: {
        "contain": "",
        "source": source,
        "src": _vm.targetImage(source),
        "aspect-ratio": "1"
      }
    })], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d26c4428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/TargetRenderer.vue
// module id = 1991
// module chunks = 0